export default {
  title: 'System eFactura',
  unavailable: 'We\'re sorry , but the url you requested is not available. Please, contact with your provider.'
}
